export const USE_SINGLE_PROJECT_QUERY_KEY = "useSingleProjectQuery";
export const USE_PROJECT_COLLECTION_QUERY_KEY = "useProjectCollectionQuery";
